import { AppBar, Toolbar, Typography, Button } from "@mui/material";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";

export default function AppBarUser({ title, onLogout }) {
  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        top: 0,
        zIndex: 1100,
        backgroundColor: "#1565C0",
        borderBottom: "1px solid rgba(255,255,255,0.1)",
      }}
    >
      <Toolbar sx={{ minHeight: "52px !important", py: 0.5 }}>
        <Typography
          variant="h6"
          component="div"
          sx={{ flexGrow: 1, fontWeight: 600, fontSize: 17 }}
        >
          {title}
        </Typography>
        <Button
          color="inherit"
          size="small"
          endIcon={<LogoutRoundedIcon sx={{ fontSize: 16 }} />}
          sx={{
            textTransform: "none",
            fontWeight: 500,
            fontSize: 13,
            borderRadius: "20px",
          }}
          onClick={() => onLogout()}
        >
          Logout
        </Button>
      </Toolbar>
    </AppBar>
  );
}
